<template>
  <v-card class="mt-3 rounded-card">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="headline font-weight-bold">
          Negociações
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-action v-if="hasModuleGerencia">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               v-if="showNegociar"
               :disabled="showCadastro"
               @click="onClickNegociar">
          <v-icon>
            mdi-plus
          </v-icon>
          Negociação
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-card-text class="text--primary">
      <div v-if="showCadastro">
        <px-resposta-negociacao-cadastro
          :resposta="resposta"
          :dialog="dialog"
          @cancel="onCancel"
          @negociacaoEnviada="onEnviada"/>
      </div>
      <div v-if="!loading && !negociacoes.length"
           align="center"
           class="headline mb-5">
        Ainda não há nenhuma negociação realizada
      </div>
      <div v-if="negociacoes.length">
        <px-resposta-negociacao-lista :negociacoes="negociacoes" :resposta="resposta"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { SituacaoCotacao } from 'px-business-components';
import { mapGetters } from 'vuex';
import NegociacaoService from './negociacao-service';
import RespostaNegociacaoCadastro from './cadastro/RespostaNegociacaoCadastro.vue';
import RespostaNegociacaoLista from './lista/RespostaNegociacaoLista.vue';

export default {
  props: {
    resposta: Object,
    dialog: Boolean,
  },
  data() {
    return {
      loading: false,
      negociacoes: [],
      showCadastro: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia']),
    showNegociar() {
      return this.resposta.cotacao.situacao === SituacaoCotacao.keys.ABERTA.key;
    },
  },
  methods: {
    onClickNegociar() {
      this.showCadastro = true;
    },
    onCancel() {
      this.showCadastro = false;
    },
    onEnviada() {
      this.showCadastro = false;
      this.getNegociacoes();
    },
    getNegociacoes() {
      this.loading = true;
      NegociacaoService.getNegociacoes(this.resposta.cotacao.id, this.resposta.id)
        .then((response) => {
          this.negociacoes = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getNegociacoes();
  },
  components: {
    pxRespostaNegociacaoCadastro: RespostaNegociacaoCadastro,
    pxRespostaNegociacaoLista: RespostaNegociacaoLista,
  },
};
</script>
